import React from 'react';

/**
 * @typedef {object} TimerProps
 * @property {number} [secondRemaining]
 */

/**
 * @param {TimerProps} props
 */
const Timer = props => {
  const { secondRemaining } = props;
  const minutes = Math.floor(secondRemaining / 60);
  const seconds = Math.floor(secondRemaining % 60)
    .toString()
    .padStart(2, '0');

  return (
    <span>
      {minutes}:{seconds}
    </span>
  );
};

export default Timer;
